import { memo } from 'react'

const FCFaqPage = () => <div>1</div>

export const FaqPage = memo(FCFaqPage)
